import React from "react";
import { Link } from "react-router-dom";

export default function Card({ recipe }) {
	return (
		<Link
			to={`/recipe/${recipe.id}`}
			key={recipe.id}
			style={{
				marginBottom: "1rem",
				width: "100%",
				display: "inline-block",
			}}>
			<div className="card">
				<div
					className="card-image"
					style={{
						backgroundImage: `url(${recipe.photo?.imageUrl}), linear-gradient(141deg, rgb(210, 210, 210) 0px, rgb(100, 100, 100) 100%)`,
						backgroundSize: "cover",
					}}></div>
				<div className="card-content">
					<div className="media" style={{marginBottom: recipe.description ? null : 0}}>
						<div className="media-content">
							<p className="title is-6">{recipe.title}</p>
						</div>
					</div>
					<div
						className="content"
						dangerouslySetInnerHTML={{
							__html: recipe.description,
						}}></div>
				</div>
			</div>
		</Link>
	);
}
